import styled from '@emotion/styled';

export const FooterWrapper = styled.div<{
  isForTypWidget: boolean;
  color?: string;
  showLogo?: boolean;
}>`
  background-color: ${props => props.color ?? '#001625'};
  height: 5rem;
  z-index: 1;
  position: ${props => (props.isForTypWidget ? 'unset' : 'sticky')};
  bottom: 0;
  width: 100%;
  padding: 1rem;
  gap: 1rem;
  display: flex;
  justify-content: ${props => (props.showLogo ? 'space-between' : 'flex-end')};
  align-items: center;
  // position: sticky;
  bottom: 0;

  position: static;
  height: unset;
  @media screen and (max-width: 576px) {
    flex-direction: column;
  }
`;

export const LinksWrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;

  @media screen and (max-width: 576px) {
    flex-direction: column;
  }
`;
